
import GetSeoData from "../API/GetSeoData";
import ThankyouAppointmentIcon from "../img/thankyuForBooking.png";
import "./ThankyouAppointmentPage.css";
import { Link } from "react-router-dom";
export default function ThankyouOnRequest() {

  return (
    <section className="spacing pb-4 blank-section thankyou-appo-page mt-lg-5 pt-5">
      <GetSeoData id={null} type="thankyou" />
      <div className="container-fluid mt-lg-4 pt-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div>
              <img
                src={ThankyouAppointmentIcon}
                alt="Appointment Booked"
                className="img-fluid"
              />
            </div>
            <div>
              <h1>Thank You for Booking</h1>
              <p>
                Thank you for your consultation request with Dr. Surabhi Bhatnagar.
                Our team will reach out to you shortly to assist you further.
              </p>
            </div>
            <div>
              <div className="read-more">
                <Link className="d-inline-block" to="/">
                  {" "}
                  Go to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
